export const Get_All_Categories_Success="Get_All_Categories_Success"

export const Get_All_Products_Success="Get_All_Products_Success"
export const Get_Products_Success_DataCount="Get_Products_Success_DataCount"
export const Get_All_Search_Products_Success="Get_All_Search_Products_Success"
export const Change_Saerch="Change_Saerch"

export const Add_To_Cart="Add_To_Cart"
export const Remove_From_Cart="Remove_From_Cart"
export const Get_Cart_List="Get_Cart_List"
export const Get_Cart_List_Error="Get_Cart_List"
export const Check_Out_Error="Check_Out_Error"
export const Check_Out_Success="Check_Out_Success"
export const Login_User_Success="Login_User_Success"
export const Login_User_Error="Login_User_Error"

export const Get_All_Settings_Success="Get_All_Settings_Success"

export const Get_All_Manufacturer_Success="Get_All_Manufacturer_Success"

export const Get_All_Country_Success="Get_All_Country_Success"